import { Inject, Injectable, forwardRef} from '@angular/core';
import { Location } from '@angular/common';
import { Http, Response, RequestOptions, ConnectionBackend, RequestOptionsArgs, Request, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { LoginAccess } from '../../entities/login-access';
import { Settings } from '../../settings';

declare var loginAccess:LoginAccess;

export class HttpClient extends Http{

    public static authorization:string;
    public loginAccess:LoginAccess = loginAccess;

    // JB: forwardRef() solves instantiation before declaration issue:
    // http://stackoverflow.com/a/41093099/2153115
    constructor(
        @Inject(forwardRef(() => ConnectionBackend)) _backend: ConnectionBackend, 
        @Inject(forwardRef(() => RequestOptions)) _defaultOptions: RequestOptions, 
        @Inject(forwardRef(() => Location)) private location:Location){
        super(_backend, _defaultOptions);

        if(loginAccess){
            HttpClient.authorization = loginAccess.AccessToken = loginAccess.accessToken;
        }
    }
    // /**
    //  * Performs any type of http request. First argument is required, and can either be a url or
    //  * a {@link Request} instance. If the first argument is a url, an optional {@link RequestOptions}
    //  * object can be provided as the 2nd argument. The options object will be merged with the values
    //  * of {@link BaseRequestOptions} before performing the request.
    //  */
    // request(url: string | Request, options?: RequestOptionsArgs): Observable<Response>{
    //     options = this.buildOptionsWithAuthorization(options);

    //     return super.request(url, options).catch(this.handleError);
    // }

    /**
     * Performs a request with `get` http method.
     */
    get(url: string, options?: RequestOptionsArgs): Observable<Response>{
        options = this.buildOptionsWithAuthorization(options);

        return super.get(url, options).catch(this.handleError);
    }

    /**
     * Performs a request with `post` http method.
     */
    post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response>{
        options = this.buildOptionsWithAuthorization(options);

        return super.post(url, body, options).catch(this.handleError);
    }

    /**
     * Performs a request with `put` http method.
     */
    put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response>{
        options = this.buildOptionsWithAuthorization(options);

        return super.put(url, body, options).catch(this.handleError);
    }

    /**
     * Performs a request with `delete` http method.
     */
    delete(url: string, options?: RequestOptionsArgs): Observable<Response>{
        options = this.buildOptionsWithAuthorization(options);

        return super.delete(url, options).catch(this.handleError);
    }

    /**
     * Performs a request with `patch` http method.
     */
    patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response>{
        options = this.buildOptionsWithAuthorization(options);

        return super.patch(url, body, options).catch(this.handleError);
    }

    /**
     * Performs a request with `head` http method.
     */
    head(url: string, options?: RequestOptionsArgs): Observable<Response>{
        options = this.buildOptionsWithAuthorization(options);

        return super.head(url, options).catch(this.handleError);
    }

    /**
     * Performs a request with `options` http method.
     */
    options(url: string, options?: RequestOptionsArgs): Observable<Response>{
        options = this.buildOptionsWithAuthorization(options);

        return super.options(url, options).catch(this.handleError);
    }


    protected buildOptionsWithAuthorization(options?: RequestOptionsArgs):RequestOptionsArgs{
        //No authorization has been set.  Return the options as-is
        if(!HttpClient.authorization){
            return options;
        }

        if(!options){
            options = new RequestOptions({});
        }

        if(!options.headers){
            options.headers = new Headers({});
        }

        //Allow the developer to override Authorization manually
        if(!options.headers.has("Authorization")){
            options.headers.set("Authorization", `Bearer ${HttpClient.authorization}`);
        }

        return options;
    }

    protected handleError = (errorResponse:Response, response:Observable<Response>):Observable<Response> => {
        if(errorResponse.status == 401 && Settings.redirectUnauthorizedResponses){
            //This isn't working on the server.  Not sure why
            //this.location.go(Settings.unauthorizedRedirectUrl);
            window.location.href = Settings.unauthorizedRedirectUrl;
        }

        return Observable.throw(errorResponse);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/http-client.service.ts